var map = {
	"./arrow-down-blue.svg": 393,
	"./arrow-down-grey.svg": 394,
	"./arrow-right-white.png": 395,
	"./arrow-right.svg": 396,
	"./blue-loader.svg": 161,
	"./circle-grey.svg": 397,
	"./circle.svg": 398,
	"./coinbaseWalletIcon.svg": 116,
	"./coins/avax.svg": 162,
	"./coins/bnb.svg": 163,
	"./coins/cro.svg": 164,
	"./coins/dai.svg": 165,
	"./coins/ech.svg": 166,
	"./coins/eth.svg": 94,
	"./coins/ftm.svg": 167,
	"./coins/kava.svg": 168,
	"./coins/kcs.svg": 169,
	"./coins/matic.svg": 170,
	"./coins/metis.svg": 399,
	"./coins/mtv.png": 171,
	"./coins/one.svg": 400,
	"./coins/sonic.png": 172,
	"./dropdown-blue.svg": 401,
	"./dropdown.svg": 402,
	"./dropup-blue.svg": 403,
	"./ethereum-logo.png": 404,
	"./fortmaticIcon.png": 117,
	"./link.svg": 405,
	"./magnifying-glass.svg": 406,
	"./menu.svg": 407,
	"./metamask.png": 173,
	"./mtvguru.png": 160,
	"./mtvscout.png": 115,
	"./plus-blue.svg": 408,
	"./plus-grey.svg": 409,
	"./portisIcon.png": 118,
	"./question-mark.svg": 410,
	"./question.svg": 411,
	"./spinner.svg": 412,
	"./token-list/lists-dark.png": 174,
	"./token-list/lists-light.png": 175,
	"./trustWallet.png": 413,
	"./walletConnectIcon.svg": 119,
	"./x.svg": 414
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 148;